import React, { useContext, useState } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import './Header.css';
import OlxLogo from '../../assets/OlxLogo';
import SearchIcon from '../../assets/SearchIcon';
import { AuthContext } from '../../contextStore/AuthContext';
import { useSearchFilter } from '../../hooks/useSearchFilter';
import NotificationBell from '../Notifications/NotificationBell';
import UserDropdown from './UserDropdown'; // Removed LocationDropdown import
import MobileMenu from './MobileMenu';

function Header() {
  const history = useHistory();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const loginState = { from: { pathname: location.pathname } };

  const {
    filteredData,
    wordEntered,
    isOpen,
    wrapperRef,
    handleFilter,
    clearInput,
    closeDropdown,
    handleSelectedSearch,
    handleKeyDown,
  } = useSearchFilter();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleSearchSubmit = () => {
    const searchTerm = wordEntered.trim();
    // Setting location to 'India' by default in the query string
    if (searchTerm) {
      history.push(`/search?q=${encodeURIComponent(searchTerm)}&location=India`);
    } else {
      history.push('/search?location=India');
    }
    closeDropdown();
  };

  return (
    <div className="headerParentDiv">
      <div className="headerChildDiv">
        {/* Mobile Hamburger */}
        <button
          type="button"
          className="headerHamburger"
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Open menu"
        >
          <span />
          <span />
          <span />
        </button>

        {/* Brand Logo */}
        <Link to="/" className="brandName">
          <OlxLogo />
        </Link>

        {/* Location Filter Removed from here */}

        {/* Navigation Links */}
        <nav className="headerNavLinks">
          <Link to="/" className={location.pathname === '/' ? 'navActive' : ''}>Home</Link>
          <Link to="/search" className={location.pathname === '/search' ? 'navActive' : ''}>Buy Equipment</Link>
          <Link to="/create">Sell Your Clubs</Link>
          <Link to="/category/junior">Junior Golf</Link>
          <Link to="/help">How It Works</Link>
          <Link to="/about">About</Link>
        </nav>

        {/* Search Wrapper */}
        <div className="headerSearchWrap" ref={wrapperRef}>
          <div className="headerSearchInner">
            <div className="mockupSearchIcon">
               <SearchIcon />
            </div>
            <input
              type="text"
              placeholder="Search clubs, brands..."
              value={wordEntered}
              onChange={handleFilter}
              onKeyDown={(e) => {
                handleKeyDown(e);
                if (e.key === 'Enter') handleSearchSubmit();
              }}
            />
            {wordEntered.trim() && (
              <button
                type="button"
                className="headerClearBtn"
                onClick={clearInput}
                aria-label="Clear search"
              >
                &times;
              </button>
            )}
          </div>
          {isOpen && filteredData.length > 0 && (
            <div className="dataResult-header">
              {filteredData.slice(0, 15).map((value, key) => (
                <div
                  key={value.id || key}
                  className="dataItem-header"
                  role="button"
                  tabIndex={0}
                  onClick={() => handleSelectedSearch(value)}
                >
                  <p>{value.name}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Right Side - Profile & Notifications */}
        <div className="headerRight">
          {user ? (
            <>
              <NotificationBell />
              <UserDropdown />
            </>
          ) : (
            <Link
              to={{ pathname: '/login', state: loginState }}
              className="headerLoginLink"
            >
              Login
            </Link>
          )}
        </div>
      </div>

      <MobileMenu
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />
    </div>
  );
}

export default Header;
